// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"8181c5c6","513":"3e71b649","787":"0ce25c46"}[chunkId] + ".chunk.js";
};